import React, { Component } from 'react'
import Row from 'react-bootstrap/Row'
import Col from 'react-bootstrap/Col'
import FormAporte from './formAporte'
import FormResgate from './formResgate'
import { Button, Modal, Card } from 'antd'

import './beta.css'

class ModalAporteSaque extends Component {
    constructor(props) {
        super(props)
        this.state = {
            loading: null,
            message: '',
            success: false,
            tipo: props.tipo,
            tipoContrato: props.contrato.tipoContrato,
            idContrato: props.contrato.id,
            file: null,
            contrato: props.contrato,
            userId: props.userid
        }
    }


    componentWillMount() {
        if (this.interval) {
            clearTimeout(this.interval)
        }
    }


    render() {
        return (
            <div className="animated fadeIn">
                <Row>
                    <Col md={12}>
                        <h5 className="aporteTitle text-dark text-center mb-4">Por favor, preencha o formulário abaixo para concluir sua solicitação</h5>
                    </Col>
                </Row>
                    {this.state.tipo === 'Aporte' ? (
                    <Row>
                        <Col md={7}>
                            <FormAporte userId={this.state.userId} tipo={this.state.tipoContrato} idContrato={this.state.idContrato} />
                        </Col>
                        <Col md={5} className="desktop">
                            <div className="limiterDeposito">
                                <h6 className="tx-light-pink">2. Faça o depósito para a conta <span className="tx-pink">{process.env.REACT_APP_NAME}</span></h6>
                                <div className="limiterBancoInfo">
                                    <label className="tx-light-pink">Banco: </label><br />
                                    <label className="text-white">{this.state.tipoContrato === 6 ? '336 - C6 Bank S.A' : '260 - Nu Pagamentos S.A'}</label>
                                </div>
                                <div className="limiterBancoInfo">
                                    <label className="tx-light-pink">Nome: </label><br />
                                    <label className="text-white">Lemon Empreendimentos Eireli</label>
                                </div>
                                <div className="limiterBancoInfo">
                                    <label className="tx-light-pink">CNPJ: </label><br />
                                    <label className="text-white">06.979.704/0001-34</label>
                                </div>
                                <div className="limiterBancoInfo">
                                    <label className="tx-light-pink">Agência: </label><br />
                                    <label className="text-white">0001</label>
                                </div>
                                <div className="limiterBancoInfo">
                                    <label className="tx-light-pink">Conta: </label><br />
                                    <label className="text-white">{this.state.tipoContrato === 6 ? '2099432-0' : '11378755-7'}</label>
                                </div>
                            </div>                            
                        </Col>
                        <Col md={12}>
                            {this.state.tipoContrato === 6 ? (
                                <small className="lineTerm tx-light-grey mt-5">*Aporte mínimo de R$500,00;<br/></small>
                            ) : (
                                <small className="lineTerm tx-light-grey mt-5">*Aporte mínimo de R$200,00;<br/></small>
                            )}
                            <small className="lineTerm tx-light-grey mt-5">*Deve ser feito via TED;<br/>*Deve ser realizado de uma conta bancária de sua titularidade;<br/>*Após aprovação, o saldo será contabilizado em D+1;<br/></small>
                            {this.state.tipoContrato !== 6 ? (
                                <small className="lineTerm tx-light-grey mt-5">*A data de término do contrato em andamento não sofre alteração;<br/></small>
                            ) : ('')}
                            <small className="lineTerm tx-light-grey mt-5">*Não existem taxas para a realização de aportes;</small>
                        </Col>
                    </Row>
                ) : (
                    <Row>
                    <Col md={7}>
                        <FormResgate userId={this.state.userId} tipo={this.state.tipoContrato} idContrato={this.state.idContrato} />
                    </Col>
                    <Col md={5}>
                        <Card title="Confirme seus dados bancários" className="limiterDeposito" >
                            <div className="limiterBancoInfo">
                                <label className="text-dark">Banco: </label><br />
                                <label className="text-dark">{this.state.contrato.codigoBanco} - {this.state.contrato.nomeBanco}</label>
                            </div>
                            <div className="limiterBancoInfo">
                                <label className="text-dark">Agência bancária: </label><br />
                                <label className="text-dark">{this.state.contrato.numeroAgencia}</label>
                            </div>
                            <div className="limiterBancoInfo">
                                <label className="text-dark">Conta bancária: </label><br />
                                <label className="text-dark">{this.state.contrato.numeroConta}</label>
                            </div>
                        </Card>                            
                    </Col>
                    <Col md={12}>
                        <small className="lineTerm tx-light-grey mt-5">taxa do saque é de 5% do valor do resgate será descontado do valor final do resgate na transação.</small>
                    </Col>
                </Row>
                )}
            </div>
        )
    }
}

export default ModalAporteSaque